<div class="store-indicator-container-mobile">
  <div class="store-images-mobile">
    <img [alt]="getMediaIconAlt('itunes')" class="store-icon" [class.store-icon_appletv]="title == 'itunes'" *ngIf="title == 'itunes'" [src]="getItunesIconSrc()">
    <img [alt]="getMediaIconAlt('amazon')" class="store-icon" *ngIf="title == 'amazonPrimeVideo'" [src]="getAmazonSrc()">
    <img [alt]="getMediaIconAlt('googlePlay')" class="store-icon" *ngIf="title == 'googlePlay'" [src]="getGooglePlaySrc()">
    <img [alt]="getMediaIconAlt('vudu')" class="store-icon" *ngIf="title == 'vudu'" [src]="getVuduSrc()">
  </div>
  <div class="title-container">
    <span class="title">{{ getCarouselTitle() }}</span>
  </div>
</div>

<div class="carousel-container">

<div class="store-indicator-container">
  <div class="store-images">
    <img [alt]="getMediaIconAlt('itunes')" class="store-icon" [class.store-icon_appletv]="title == 'itunes'" *ngIf="title == 'itunes'" [src]="getItunesIconSrc()">
    <img [alt]="getMediaIconAlt('amazon')" class="store-icon" *ngIf="title == 'amazonPrimeVideo'" [src]="getAmazonSrc()">
    <img [alt]="getMediaIconAlt('googlePlay')" class="store-icon" *ngIf="title == 'googlePlay'" [src]="getGooglePlaySrc()">
    <img [alt]="getMediaIconAlt('vudu')" class="store-icon" *ngIf="title == 'vudu'" [src]="getVuduSrc()">
  </div>
  <div class="title">{{ getCarouselTitle() }}</div>
</div>

<div class="media-selector-container">
    <div class="media-indicator-images">
      <img alt="" class="arrow-icon" src="./assets/images/left_arrow.png" (click)="slide(-1)">
      <div class="img-hover">

        <div class="media-container" *ngIf="containsCategory('movies')" (click)="mediaChanged('movies')">
          <!-- <div class="media-name" *ngIf="containsCategory('movies')"><span class="text">{{getString('movies')}}</span></div> -->
          <span class="material-icons media-icon" [class.active]="isActiveCategory('movies')" [title]="getMediaIconAlt('movies')">{{getMaterialIcon('movies')}}</span>
        </div>

        <div class="media-container" *ngIf="containsCategory('seasons')" (click)="mediaChanged('seasons')">
          <!-- <div class="media-name" *ngIf="containsCategory('seasons')"><span class="text">{{getString('seasons')}}</span></div> -->
          <span class="material-icons media-icon" [class.active]="isActiveCategory('seasons')" [title]="getMediaIconAlt('seasons')">{{getMaterialIcon('seasons')}}</span>
        </div>

        <div class="media-container" *ngIf="containsCategory('albums')" (click)="mediaChanged('albums')">
          <!-- <div class="media-name" *ngIf="containsCategory('albums')"><span class="text">{{getString('albums')}}</span></div> -->
          <span class="material-icons media-icon" [class.active]="isActiveCategory('albums')" [title]="getMediaIconAlt('albums')">{{getMaterialIcon('albums')}}</span>
        </div>

        <div class="media-container" *ngIf="containsCategory('audiobooks')" (click)="mediaChanged('audiobooks')">
          <!-- <div class="media-name" *ngIf="containsCategory('audiobooks')"><span class="text">{{getString('audiobooks_break')}}</span></div> -->
          <span class="material-icons media-icon" [class.active]="isActiveCategory('audiobooks')" [title]="getMediaIconAlt('audiobooks')">{{getMaterialIcon('audiobooks')}}</span>
        </div>

        <div class="media-container" *ngIf="containsCategory('ebooks')" (click)="mediaChanged('ebooks')">
          <!-- <div class="media-name" *ngIf="containsCategory('ebooks')"><span class="text">{{getString('ebooks')}}</span></div> -->
          <span class="material-icons media-icon" [class.active]="isActiveCategory('ebooks')" [title]="getMediaIconAlt('ebooks')">{{getMaterialIcon('ebooks')}}</span>
        </div>

        <div class="media-container" *ngIf="containsCategory('apps')" (click)="mediaChanged('apps')">
          <!-- <div class="media-name" *ngIf="containsCategory('apps')"><span class="text">{{getString('apps')}}</span></div> -->
          <span class="material-icons media-icon" [class.active]="isActiveCategory('apps')" [title]="getMediaIconAlt('apps')">{{getMaterialIcon('apps')}}</span>
        </div>

      <div class="media-container" *ngIf="containsCategory('macapps')" (click)="mediaChanged('macapps')">
        <!-- <div class="media-name" *ngIf="containsCategory('macapps')"><span class="text">{{getString('macapps')}}</span></div> -->
        <span class="material-icons media-icon" [class.active]="isActiveCategory('macapps')" [title]="getMediaIconAlt('macapps')">{{getMaterialIcon('macapps')}}</span>
      </div>

      </div>

      <img alt="" class="arrow-icon" src="./assets/images/right_arrow.png" (click)="slide(1)">

    </div>
  </div>

  <div class="carousel-content">

    <div #carouselCategoryDiv class="category" [style.margin-left.px]="carouselMarginLeft">
      <app-grid-item class="item" *ngFor="let item of items[categories[0]]"
        [item]="item" [priceHint]="'home'" [isCarouselItem]="true" [store]="titleToStore" [media]="categories[0]"
        (onWishlistClicked)="addToWishlist(item)"
        (onOwnlistClicked)="addToOwnlist(item)"
        (onBlocklistClicked)="addToBlocklist(item)"
        (onRemoveFromWishlistClicked)="removeFromWishlist(item)"
        (onRemoveFromOwnlistClicked)="removeFromOwnlist(item)"
      >
      </app-grid-item>

      <div [class]="getMoreDivClass(0)">
          <a class="more-offers-link" [routerLink]="[moreOffersURL]">{{getString('more_'+categories[carouselPosition])}}</a>
        <img alt="" class="more-arrow" src="./assets/images/right_arrow.png">
      </div>

    </div>

    <ng-container *ngFor="let key of categories; let i = index">
      <div class="category" *ngIf="i != 0">
        <app-grid-item class="item" *ngFor="let item of items[key]"
          [item]="item" [priceHint]="'home'" [isCarouselItem]="true" [store]="titleToStore" [media]="key"
          (onWishlistClicked)="addToWishlist(item)"
          (onOwnlistClicked)="addToOwnlist(item)"
          (onBlocklistClicked)="addToBlocklist(item)"
          (onRemoveFromWishlistClicked)="removeFromWishlist(item)"
          (onRemoveFromOwnlistClicked)="removeFromOwnlist(item)"
        >
        </app-grid-item>

        <div [class]="getMoreDivClass(i)">
          <a class="more-offers-link" [routerLink]="[moreOffersURL]">{{getString('more_'+categories[carouselPosition])}}</a>
          <img alt="" class="more-arrow" src="./assets/images/right_arrow.png">
        </div>

      </div>

    </ng-container>
  </div>






</div>
